<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import {MedButton, MedLink, MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentGuidelineButton",
  });

  defineProps({
    guidelines: {
      type: Array,
      default: () => {
        return [];
      },
    },
  });

  const refDialog = ref(null);
</script>

<template>
  <div class="ml-1 inline-block">
    <MedTooltip content="Diese Erkrankung wurde automatisiert auf leitlinienkonforme Therapie geprüft">
      <MedButton
        aria-label="Leitlinien anzeigen"
        rounded="full"
        size="xs"
        class="size-7.5 shrink-0 bg-gray-200 p-1 text-sm hover:bg-gray-300"
        :data-test="getTestId('open-guideline-dialog-button')"
        @click="refDialog.open()"
      >
        LL
      </MedButton>
    </MedTooltip>

    <ComponentDialog
      ref="refDialog"
      dialog-width="medium"
      dialog-title="Leitlinien"
      dialog-type="information"
      :test-id="getTestId('guideline')"
    >
      <template #content>
        Diese Erkrankung wurde automatisiert auf leitlinienkonforme Therapie geprüft.

        <ul class="mt-2 ml-4 list-disc space-y-4">
          <li v-for="(guideline, index) in guidelines" :key="index" class="group leading-tight">
            <MedLink
              :href="guideline.url"
              target="_blank"
              :data-test="getTestId(`guideline-${index}-url-link`)"
              class="block"
            >
              <div class="text-mcred-500 decoration-primary-500 underline-offset-2 hover:underline">
                {{ guideline.name }}
              </div>
              <div class="truncate text-xs text-gray-600">{{ guideline.url }}</div>
            </MedLink>
          </li>
        </ul>
      </template>
    </ComponentDialog>
  </div>
</template>
